module.exports = __webpack_public_path__ + "img/pay-success.4f59ade7.png";